import React from 'react'

const STICKY_SECTION_Z_INDEX = 20
const LAYOUT_WIDTHS = {
  leftSection: 400,
  rightSection: 250
} as const

export const TopShadowEffect = React.forwardRef<HTMLDivElement>((_, ref) => (
  <div
    ref={ref}
    style={{
      position: 'absolute',
      left: 0,
      right: 0,
      top: '0',
      height: '64px',
      zIndex: STICKY_SECTION_Z_INDEX + 10,
      pointerEvents: 'none',
      boxShadow: '0px 8px 8px 0px rgba(0, 0, 0, 0.05)',
      display: 'none' // Start hidden
    }}
  />
))

export const BottomShadowEffect = React.forwardRef<HTMLDivElement>((_, ref) => (
  <div
    ref={ref}
    style={{
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: '0px',
      height: '32px',
      zIndex: STICKY_SECTION_Z_INDEX + 10,
      pointerEvents: 'none',
      boxShadow: '0px -8px 8px 0px rgba(0, 0, 0, 0.05)',
      display: 'none' // Start hidden
    }}
  />
))

export const LeftShadowEffect = React.forwardRef<HTMLDivElement>((_, ref) => (
  <div
    ref={ref}
    style={{
      position: 'absolute',
      left: `${LAYOUT_WIDTHS.leftSection - 9}px`,
      top: '64px',
      bottom: '32px',
      width: '8px',
      zIndex: STICKY_SECTION_Z_INDEX + 10,
      pointerEvents: 'none',
      boxShadow: '8px 0px 8px 0px rgba(0, 0, 0, 0.05)',
      display: 'none' // Start hidden
    }}
  />
))

export const RightShadowEffect = React.forwardRef<HTMLDivElement>((_, ref) => (
  <div
    ref={ref}
    style={{
      position: 'absolute',
      right: `${LAYOUT_WIDTHS.rightSection - 9}px`,
      top: '64px',
      bottom: '32px',
      width: '8px',
      zIndex: STICKY_SECTION_Z_INDEX + 10,
      pointerEvents: 'none',
      boxShadow: '-8px 0px 8px 0px rgba(0, 0, 0, 0.05)',
      display: 'none' // Start hidden
    }}
  />
))
